import type { InferContractRouterInputs } from '@orpc/contract'
import debug from 'debug'
import type { BaseContract } from 'pixai-contract/api/orpc'

const log = debug('pixai:attribution')

export const ANONYMOUS_ID_KEY = 'attribution:anonymous-id'
export const CLICK_SENT_AT_KEY = 'attribution:click-sent-at'

export const CLICK_ID_PARAMS = {
  gclid: 'Google Ads click identifier',
  gbraid: 'Google Ads broad-match click identifier',
  wbraid: 'Google Ads web-to-app click identifier',
  fbclid: 'Facebook click identifier',
  fbc: 'Facebook click cookie',
} as const

export function parseGaClientId(
  gaCookie: string | undefined,
): string | undefined {
  if (!gaCookie) return undefined
  // _ga cookie format: GA1.1.xxx.xxx — client ID is the last two dot-separated parts
  const parts = gaCookie.split('.')
  if (parts.length >= 4) {
    return parts.slice(-2).join('.')
  }
  return undefined
}

export type ClickSentStatus = 'pending' | 'success'

export function formatClickSentValue(status: ClickSentStatus): string {
  return `${status}:${Date.now()}`
}

export function parseClickSentStatus(
  value: string | null,
): ClickSentStatus | null {
  if (!value) return null
  if (value.startsWith('pending:')) return 'pending'
  if (value.startsWith('success:')) return 'success'
  return null
}

type CreateClickEventInput =
  InferContractRouterInputs<BaseContract>['attribution']['createClickEvent']

export function extractAdClickParams(
  url: URL,
): Omit<CreateClickEventInput, 'anonymousId'> | null {
  const matched = Object.entries(CLICK_ID_PARAMS).filter(([p]) => {
    const value = url.searchParams.get(p)
    return value !== null && value.length > 0
  })
  if (matched.length === 0) return null

  for (const [id, description] of matched) {
    log('click triggered by %s (%s)', id, description)
  }

  return {
    source: url.searchParams.get('utm_source') || undefined,
    gclid: url.searchParams.get('gclid') || undefined,
    gbraid: url.searchParams.get('gbraid') || undefined,
    wbraid: url.searchParams.get('wbraid') || undefined,
    fbclid: url.searchParams.get('fbclid') || undefined,
    fbc: url.searchParams.get('fbc') || undefined,
  }
}
